<template>
  <time>
    <div class="time" :style="{color: $root.fontColor}">{{ time }}</div>
    <div class="date" :style="{color: $root.fontColor}">{{ date }}</div>
  </time>
</template>

<script>
import moment from "moment";
export default {
  name: "Time",
  components: {},
  props: {},
  data() {
    return {
      date: moment().format("ddd, MMM DD"),
      time: moment().format("HH:mm"),
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.time = moment().format("HH:mm");
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style lang="scss" scoped>
time {
  width: 80px;
  margin-right: 10px;
  color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: end;
}

.time {
  font-size: 23px;
  line-height: 20px;
  text-align: right;
}

.date {
  font-size: 10px;
  text-align: right;
}
</style>
